import type { CsatSurveyVariant } from "@redotech/redo-support-settings-common/csat-survey";

/** Variants compare by value; identity would mark the form dirty on every render. */
export const csatVariantEqual = (a: CsatSurveyVariant, b: CsatSurveyVariant) =>
  a.id === b.id &&
  a.name === b.name &&
  a.weight === b.weight &&
  a.surveySendTime === b.surveySendTime &&
  a.emailTemplateId === b.emailTemplateId;

export const newVariant = (index: number): CsatSurveyVariant => ({
  id: `variant-${index}-${Date.now()}`,
  /* The first variant is the control: it changes nothing. */
  name: index === 0 ? "Control" : `Variant ${String.fromCharCode(65 + index)}`,
  weight: 50,
});

/** A variant that overrides nothing sends exactly the default survey. */
export const variantOverrides = (variant: CsatSurveyVariant): string[] => {
  const overrides: string[] = [];
  if (variant.surveySendTime !== undefined) {
    overrides.push("send time");
  }
  if (variant.emailTemplateId !== undefined) {
    overrides.push("email template");
  }
  return overrides;
};

/** An enabled test whose variants all inherit compares identical emails. */
export const everyVariantInherits = (
  variants: readonly CsatSurveyVariant[],
): boolean =>
  variants.length > 0 &&
  variants.every((variant) => variantOverrides(variant).length === 0);
